import { createSlice } from '@reduxjs/toolkit';

import { handleRemoveSupplementFromInquiryDraft } from './actions';
import { IRemoveSupplementFromInquiryDraftState } from './slice.interface';

const initialState: IRemoveSupplementFromInquiryDraftState = {
  isLoading: false,
};

export const removeSupplementFromInquiryDraftSlice = createSlice({
  name: 'remove-supplement-from-inquiry-draft',
  initialState,
  reducers: {
    removeDeleteSupplementFromInquiryDraft: state => {
      state.isLoading = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(
        handleRemoveSupplementFromInquiryDraft.pending,
        (state: IRemoveSupplementFromInquiryDraftState) => {
          state.isLoading = true;
        },
      )
      .addCase(
        handleRemoveSupplementFromInquiryDraft.fulfilled,
        (state: IRemoveSupplementFromInquiryDraftState) => {
          state.isLoading = false;
        },
      );
  },
});

export const { removeDeleteSupplementFromInquiryDraft } =
  removeSupplementFromInquiryDraftSlice.actions;

export default removeSupplementFromInquiryDraftSlice.reducer;
